import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/#about', label: 'About' },
  { to: '/#support-issues', label: 'Help' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const closeMenu = () => setMenuOpen(false);

  const renderLink = (link) => (
    <Link
      key={link.label}
      to={link.to}
      className="site-header-link"
      onClick={closeMenu}
    >
      {link.label}
    </Link>
  );

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <div className="site-header-bar">
          <Link to="/" className="site-header-brand" onClick={closeMenu}>
            <img src="/logo.avif" alt="Family Tree Maker Logo" />
            <div className="site-header-brand-text">
              <span className="site-header-brand-main">Family Tree</span>
              <span className="site-header-brand-sub">Maker</span>
            </div>
          </Link>

          <nav className="site-header-nav-desktop" aria-label="Main navigation">
            {navLinks.map(renderLink)}
          </nav>

          <button
            type="button"
            className="site-header-toggle"
            onClick={() => setMenuOpen((open) => !open)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            aria-controls="mobile-nav"
          >
            {menuOpen ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path strokeLinecap="round" d="M6 6l12 12M18 6L6 18" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path strokeLinecap="round" d="M4 7h16M4 12h16M4 17h16" />
              </svg>
            )}
          </button>
        </div>

        {menuOpen && (
          <nav id="mobile-nav" className="site-header-menu-mobile" aria-label="Mobile navigation">
            {navLinks.map(renderLink)}
          </nav>
        )}
      </div>
    </header>
  );
}
